module.exports = __webpack_public_path__ + "dadfa0f722bec839e7f6178e8ddd179d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon-16x16.png
// module id = 2468
// module chunks = 85